const flatMap = (arr, cb) => arr.map(cb).reduce((destArray, array) => destArray.concat(array), [])

module.exports = { flatMap }
